import {
  StatsByWeekRequestData,
  StatsResultsResponseRow,
} from '../../../types/api/endpoints/stats/results.types';
import { STATS_ENDPOINTS } from '../../../utils/api/endpoints/statsEndpoints';
import {} from './useStatsByWeek.types';

const PREFIX = '[statsByWeekQuery]';

export const statsByWeekQuery = async (data: StatsByWeekRequestData) => {
  console.log(PREFIX, `Fetching stats results...`);

  const response = await STATS_ENDPOINTS.statsByWeek(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received stats results..`);
  return json as StatsResultsResponseRow[];
};
